// Razorpay configuration and service
const RAZORPAY_KEY_ID = 'rzp_live_BWxyeSW3ZkO9F2';

// Load Razorpay script
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

// Create Razorpay order and open payment modal
export const initiateRazorpayPayment = async (orderData, onSuccess, onFailure) => {
  // Load Razorpay script
  const isLoaded = await loadRazorpayScript();
  
  if (!isLoaded) {
    alert('Failed to load Razorpay. Please check your internet connection.');
    return;
  }

  const options = {
    key: RAZORPAY_KEY_ID,
    amount: Math.round(orderData.total * 100), // Amount in paise (₹1 = 100 paise)
    currency: 'INR',
    name: 'MD Sweets Caterers',
    description: 'Order Payment',
    image: '/logo192.png', // Your shop logo
    order_id: '', // Will be generated from backend in production
    handler: function (response) {
      // Payment successful
      console.log('Payment successful:', response);
      onSuccess({
        razorpay_payment_id: response.razorpay_payment_id,
        razorpay_order_id: response.razorpay_order_id,
        razorpay_signature: response.razorpay_signature
      });
    },
    prefill: {
      name: orderData.shippingInfo.fullName,
      email: orderData.shippingInfo.email,
      contact: orderData.shippingInfo.phone
    },
    notes: {
      order_items: orderData.items.length + ' items',
      delivery_address: orderData.shippingInfo.address
    },
    theme: {
      color: '#667eea'
    },
    modal: {
      ondismiss: function() {
        console.log('Payment cancelled by user');
        onFailure('Payment cancelled');
      }
    }
  };

  const razorpay = new window.Razorpay(options);
  
  razorpay.on('payment.failed', function (response) {
    console.error('Payment failed:', response.error);
    onFailure(response.error.description || 'Payment failed');
  });

  razorpay.open();
};

export { RAZORPAY_KEY_ID };
